// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/TagsPopup/styles.scss
// module id = 800
// module chunks = 0